import { StageEnum, STAGE } from './stage';

export const getYandexMetricaId = (): string | undefined => {
  return STAGE === StageEnum.Production ? '106065051' : undefined;
};

export const YANDEX_METRICA_ID = getYandexMetricaId();
